import { rest } from 'msw'

import { mockValidationSubmissionDetailsResponse } from '@percent/admin-dashboard/fixtures/api/validationSubmissions/mockValidationSubmissionDetailsResponse'
import { mockValidationSubmissionsResponse } from '@percent/admin-dashboard/fixtures/api/validationSubmissions/mockValidationSubmissionsResponse'
import { mockHeldValidationSubmissionsResponse } from '@percent/admin-dashboard/fixtures/api/validationSubmissions/mockHeldValidationSubmissionsResponse'
import { mockBulkReleaseHoldsResponse } from '@percent/admin-dashboard/fixtures/api/validationSubmissions/mockBulkReleaseHoldsResponse'
import { mockValidationSubmissionLogsResponse } from '@percent/admin-dashboard/fixtures/api/validationSubmissions/mockValidationSubmissionLogsResponse'
import { config } from '@percent/admin-dashboard/config'
import { mockValidationSubmissionConfigurationsResponse } from '@percent/admin-dashboard/fixtures/api/validationSubmissions/mockValidationSubmissionConfigurationsResponse'
import { mockValidationSubmissionConfigurationResponse } from '@percent/admin-dashboard/fixtures/api/validationSubmissions/mockValidationSubmissionConfigurationResponse'
import { mockSuccessResponse } from '@percent/admin-dashboard/fixtures/api/mockSuccessResponse'
import { mockValidationSubmissionDocument } from '@percent/admin-dashboard/fixtures/api/mockValidationSubmissionDocument'

export const validationSubmissionsHandlers = [
  rest.get(`${config.urls.api}v1/admin/validation-submissions`, async (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockValidationSubmissionsResponse))
  }),
  rest.get(`${config.urls.api}v1/admin/validation-submissions/holds`, async (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockHeldValidationSubmissionsResponse))
  }),
  rest.get(`${config.urls.api}v1/admin/validation-submissions/holds/export`, async (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.set('Content-Type', 'text/csv'),
      ctx.body('validationSubmissionId,agentVerificationId,rejectionReasonCode\n')
    )
  }),
  rest.post(`${config.urls.api}v1/admin/validation-submissions/holds/bulk-release`, async (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockBulkReleaseHoldsResponse))
  }),
  rest.post(`${config.urls.api}v1/admin/validation-submissions/:id/hold/release`, async (req, res, ctx) => {
    return res(ctx.status(204))
  }),
  rest.get(`${config.urls.api}v1/admin/validation-submissions/:id/documents`, async (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockSuccessResponse([mockValidationSubmissionDocument])))
  }),
  rest.get(`${config.urls.api}v1/admin/validation-submissions/:id`, async (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockValidationSubmissionDetailsResponse))
  }),
  rest.get(`${config.urls.api}v1/admin/validation-submissions/:id/logs`, async (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockValidationSubmissionLogsResponse))
  }),
  rest.get(
    `${config.urls.api}v1/admin/partners/:partnerId/validation-submission-configurations`,
    async (req, res, ctx) => {
      return res(ctx.status(200), ctx.json(mockValidationSubmissionConfigurationsResponse))
    }
  ),
  rest.get(`${config.urls.api}v1/admin/validation-submission-configurations/:id`, async (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockValidationSubmissionConfigurationResponse))
  }),
  rest.post(`${config.urls.api}v1/admin/validation-submission-hosted-configuration`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockValidationSubmissionDetailsResponse))
  }),
  rest.patch(`${config.urls.api}v1/admin/validation-submission-configurations/:id`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockValidationSubmissionDetailsResponse))
  }),
  rest.put(`${config.urls.api}v1/admin/validation-submission-configuration/:id/subtags`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockValidationSubmissionDetailsResponse))
  })
]
